export { BoxOfficeRail } from './BoxOfficeRail'
export type { BoxOfficeFilm, BoxOfficeRailProps } from './BoxOfficeRail'
